import { Box, Stack, Typography } from '@mui/material';

export function NoProjectMessage({
  message,
  buttonNewProject,
}: {
  message: string;
  buttonNewProject: React.ReactNode;
}) {
  return (
    <Stack
      display={'flex'}
      alignItems={'center'}
      flexDirection={'column'}
      sx={{ mb: 5 }}
    >
      <Box sx={{ pb: 2, m: 'auto' }}>
        <Typography variant="h6">{message}</Typography>
      </Box>
      <Box sx={{ m: 'auto' }}>{buttonNewProject}</Box>
    </Stack>
  );
}
